import { ICreateAndUpdateCategory } from "../../../types/category.interface";
import customAxios from "../../customAxios";
import { UPDATE_CATEGORY } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const updateCategory = async (props: ICreateAndUpdateCategory) => {
  console.log(props);
  const body = {
    categoryName: props?.categoryName,
    picture: props?.image,
    type: props?.type,
  };

  try {
    return (await customAxios.put(UPDATE_CATEGORY + `/${props._id}`, body))
      .data;
  } catch (error: unknown) {
    console.error({ UPDATE_CATEGORY: error });
    return false;
  }
};

export default updateCategory;
